import { useGatingEvaluator } from "./use-gating-evaluator";
import type {
  AuthorizationRuleGroupForGating,
  AuthorizationRuleGroupForGatingType,
} from "../use-gating-permissions";
import { computed, toValue, type MaybeRefOrGetter } from "vue";
import type { ChannelPermission } from "@f3/shared/permissions";
import { GatingAccessType } from "../gating-types";

export function useIsGated(
  group: MaybeRefOrGetter<
    AuthorizationRuleGroupForGatingType | null | undefined
  >,
  permission: ChannelPermission,
) {
  const { getRelevantRule, getGatingRuleMetadata } = useGatingEvaluator();

  const isGated = computed(() => {
    const normalized = toValue(group) as AuthorizationRuleGroupForGating;

    const rule = getRelevantRule(normalized, permission);
    return rule
      ? getGatingRuleMetadata(rule)?.accessType === GatingAccessType.limited
      : false;
  });

  return isGated;
}
